import { Validator } from '@vista-digital/validator';
import { defaultTicketPickerAssets, ticketPickerAssetsValidator } from './assets';
import { defaultTicketPickerConfig, ticketPickerConfigValidator } from './config';
import { defaultTicketPickerDisplayText, ticketPickerDisplayTextValidator } from './display-text';
import { defaultTicketPickerSubcomponents, ticketPickerSubcomponentsValidator } from './subcomponents';
export const ticketPickerPropsValidator = Validator.object({
    config: ticketPickerConfigValidator,
    displayText: ticketPickerDisplayTextValidator,
    assets: ticketPickerAssetsValidator,
    subcomponents: ticketPickerSubcomponentsValidator
});
export const defaultTicketPickerProps = {
    config: defaultTicketPickerConfig,
    displayText: defaultTicketPickerDisplayText,
    assets: defaultTicketPickerAssets,
    subcomponents: defaultTicketPickerSubcomponents
};
